import { defineFcm } from '../shared/factory';

export const FCM_OPTIMIZELY_ENABLED = defineFcm('optimizely_enabled').asBoolean().withDefault(false).toConfig();
